<template>
  <div class="sidebar" v-if="menuLists.length != 0">
    <ul
      class="menu"
      @mouseover="mouseOver"
      @mouseleave="mouseLeave"
      v-if="menuLists.length != 0"
    >
      <!--循环一级菜单-->
      <li
        class="menuitem"
        :key="index"
        v-for="(item, index) in menuLists"
        :class="{
          menuItem_active: item[keyword] == module_int,
          menuItem_see_active:
            item[keyword] == see_module_int && item[keyword] != module_int
        }"
      >

        <a-icon @mouseover="mouseItemOver(item)" :type="item.module_icon" />
        <div :class="{ isShow: isShow&&!isAlwaysCollapse, isHide: !isShow||isAlwaysCollapse }">
          <span @mouseover="mouseItemOver(item)">{{ item.module_name }}</span>
        </div>
        <a-icon v-if="isShow&&!isAlwaysCollapse" type="right" />
      </li>

      <!--循环二级菜单-->
      <ul :class="{'menu_two':true,'menu_two_collapse':isAlwaysCollapse}" v-if="currentCheckMenu.length">
        <template
          class="menuItem_two"
          v-for="(item, index) in currentCheckMenu"
        >
          <div class="menuItem_two_title">
            <div class="menuItem_two_title_content">
              <label for=""></label>
              <span class="text">
                {{ item.module_name }}
              </span>
            </div>
          </div>
          <!--循环三级菜单-->
          <div
            class="menuItem_three"
            :class="{ menuItem_three_active: ite[route] == currentUrl }"
            v-for="(ite, inde) in item[subMenuList]"
            @click="toPath(ite, item)"
            :key="ite.module_id"
          >
            <span class="menuName">
              {{ ite.module_name }}
              <div
                class="count"
                v-if="
                  $store.state.redListMap &&
                  $store.state.redListMap[ite[keyword]]
                "
              >
                {{ $store.state.redListMap[ite[keyword]] | redMax }}
              </div>
            </span>
          </div>
        </template>
      </ul>

      <!--当前二级菜单-->
    </ul>
    <ul
      class="currentMenu"
      :class="{ shrink: is_shrink }"
      v-if="menuLists.length && currentMenu.length && !isShow"
    >
      <li
        class="currentMenuItem"
        v-for="(item, index) in currentMenu"
        :key="index"
      >
        <div class="currentMenuItem_title">
          <div class="menuItem_two_title_content">
            <label for=""></label>
            <span class="text">
              {{ item.module_name }}
            </span>
          </div>
        </div>
        <div
          class="currentMenuItem_two"
          :class="{ currentMenuItem_two_active: ite[route] == currentUrl }"
          v-for="(ite, inde) in item[subMenuList]"
          @click="toPath(ite, item)"
          :key="inde"
        >
          <span class="menuName">
            {{ ite.module_name }}
            <div
              class="count"
              v-if="
                $store.state.redListMap && $store.state.redListMap[ite[keyword]]
              "
            >
              {{ $store.state.redListMap[ite[keyword]] | redMax }}
            </div>
          </span>
        </div>
      </li>
    </ul>

    <div class="caret-left" v-if="!is_shrink" @click="onShrink(true)">
      <a-icon type="caret-left" />
    </div>
    <div class="caret-right" v-if="is_shrink" @click="onShrink(false)">
      <a-icon type="caret-right" />
    </div>
  </div>
</template>
<script>
export default {
  data: () => ({
    isShow: false,
    
    //当前查看的二级菜单
    currentCheckMenu: [],
    //当前二级菜单
    currentMenu: [],
    //当前一级菜单id
    module_int: '',
    //当前页面地址
    currentUrl: '',

    //当前查看的一级菜单id
    see_module_int: '',

    menuLists: [],

    //收缩|展开二级菜单
    is_shrink: false
  }),
  props: {
    isAlwaysCollapse:Boolean,
    //侧边栏数据
    menuList: {
      type: Array
    },
    //隐藏侧边栏的页面
    hidePage: {
      type: Array
    },
    //唯一标识 默认 module_int
    keyword: {
      default: 'module_int'
    },
    
    //三级菜单列表key 默认 subMenuList
    subMenuList: {
      default: 'subMenuList'
    },
    //跳转页面URL key 默认 module_es
    route: {
      default: 'module_es'
    },
    //icon key 默认 module_icon
    icon: {
      default: 'module_icon'
    }
  },
  filters: {
    redMax: function (value) {
      console.log(value)
      if (value - 0 > 99) {
        return '99+'
      } else {
        return value
      }
    }
  },
  computed: {
    /*
     * 必须保留，否则会出现BUG
     * */
    navigationtData() {
      return this.$store.state.subSystemList
    }
  },
  watch: {
    navigationtData(val) {
      if (this.currentMenu.length == 0) {
        //在切换终端时判断如果没有二级菜单的数据才展开一级菜单
        this.isShow = true
      }
      if (this.currentMenu.length == 0 && this.isShow) {
        //当前是否有二级菜单数据并且显示已经菜单
        this.$emit('onsetCurrentMenu', false)
      } else {
        //当前是否有二级菜单数据并且显示已经菜单
        this.$emit('onsetCurrentMenu', true)
      }
      //侧边栏宽度变化调用
      this.$emit('onWidthChange', this.is_shrink)

      console.log(val)
    },
    $route(e) {
      if (this.hidePage.indexOf(e.fullPath) >= 0) {
        console.log(e.fullPath, 'fullPath')
        setTimeout(() => {
          //清除所有状态和数据，使侧边栏隐藏
          // this.menuList = [];
          this.menuLists = []
          //侧边栏宽度变化调用
          this.$emit('onWidthChange', this.is_shrink)
          this.isShow = false
          this.currentMenu = []
          this.module_int = ''
          this.see_module_int = ''
          this.currentUrl = ''
          this.onShrink(this.is_shrink)
        })
        this.menuLists = []
        console.log(this.menuLists)
        //当前是否有二级菜单数据并且显示已经菜单
        this.$emit('onsetCurrentMenu', false)
        this.$store.commit('setHideNavbar', true)
      } else {
        this.getCurrentMenu(e.fullPath)
        setTimeout(() => {
          this.getCurrentMenu(e.fullPath)
        }, 1000)
      }
    },
    menuList(e) {
      //获取当前url
      let currentUrl = window.location.hash.split('#')[1]
      this.currentUrl = currentUrl

      if (this.hidePage.indexOf(currentUrl) >= 0) {
      } else {
        this.menuLists = JSON.parse(JSON.stringify(this.menuList))
      }
    }
  },
  mounted() {},
  methods: {
    //初始化
    init() {
      //获取当前url
      let currentUrl = window.location.hash.split('#')[1]
      this.currentUrl = currentUrl

      if (this.hidePage.indexOf(currentUrl) >= 0) {
      } else {
        this.menuLists = JSON.parse(JSON.stringify(this.menuList))
        this.getCurrentMenu(currentUrl)
        setTimeout(() => {
          this.getCurrentMenu(currentUrl)
        }, 1000)
      }
      console.log(this.$route)
      this.onShrink(this.is_shrink)
    },
    /*
     * 根据url高亮当前页面的一级菜单和二级菜单
     * */
    getCurrentMenu(url) {
      let module_int = null
      this.menuLists.forEach((e) => {
        if (e.menuList) {
          e.menuList.forEach((item) => {
            let currentItem = item[this.subMenuList].filter(
              (ite) => url == ite[this.route]
            )

            if (currentItem.length != 0) {
              this.isShow = false
              //设置当前二级菜单(页面初次加载)
              this.currentMenu = e.menuList
              this.module_int = e[this.keyword]
              module_int = currentItem.module_int
            }
          })
        }
      })
      this.currentUrl = url
      if (module_int) {
        localStorage.setItem('current_page_module_int', module_int)
      }
      if (this.currentMenu.length == 0 && this.isShow) {
        //当前是否有二级菜单数据并且显示已经菜单
        this.$emit('onsetCurrentMenu', false)
      } else {
        //当前是否有二级菜单数据并且显示已经菜单
        this.$emit('onsetCurrentMenu', true)
      }
      this.onShrink(this.is_shrink)
    },
    /*
     * 跳转页面
     * */
    toPath(e, p) {
      this.onShrink(false)
      console.log(e)
      console.log(p)
      //设置当前二级菜单(页面跳转)
      if (this.currentCheckMenu.length != 0) {
        this.currentMenu = this.currentCheckMenu

        this.module_int = this.currentCheckMenu[0][this.keyword]
      }
      this.isShow = false
      this.currentCheckMenu = []
      let oldRootPath = this.$route.path.split('/')[1]
      let newRootPath = e[this.route].split('/')[1]
      console.log(oldRootPath, newRootPath, 'newRootPath===>')
      if (oldRootPath == newRootPath || oldRootPath == 'home') {
        this.$router.push({ path: e[this.route] })
        this.currentUrl = e[this.route]
      } else {
        let r = this.$router.resolve({
          path: e[this.route]
        })
        window.open(r.href)
      }

      //埋点
      //埋点的菜单 的父级菜单(一级菜单)
      let parent_module_int = [
        201000000, //主数据维护
        202000000, //档案操作管理
        203000000, //主数据 系统设置
        101000000, //部门/辖区管理
        102000000, //指标管理
        103000000, //辖区管理 系统设置
        301000000, //工作中心
        302000000, //OA办公管理
        304000000, //行为统计报表
        307000000, //绩效考核管理
        305000000, //合规管理
        306000000, //行为管理系统 系统设置
        401000000, //渠道发货管理
        402000000, //流向导入
        403000000, //流向智能清洗
        404000000, //别名管理
        405000000, //原始数据查询
        406000000, //流向统计分析
        407000000, //彩蝶  系统设置
        1001000000, //档案信息管理
        1002000000, //服务项目管理
        140100000 //云拜访
      ]
      if (parent_module_int.indexOf(p.parent_module_int) > -1) {
        this.menuBuryingPoint(e.module_int)
      }
    },
    /*
     * 移入侧边栏
     * */
    mouseOver() {
      this.isShow = true
      //侧边栏宽度变化调用
      this.$emit('onWidthChange', this.is_shrink)
      this.onShrink(this.is_shrink)
    },
    /*
     * 移出侧边栏
     * */
    mouseLeave() {
      if (this.currentMenu.length == 0) {
        //侧边栏宽度变化调用
        this.$emit('onWidthChange', !this.isShow && this.is_shrink)
      } else {
        this.isShow = false
      }
      this.currentCheckMenu = []
      this.see_module_int = ''
      this.onShrink(this.is_shrink)
    },
    /*
     * 移入导航
     * */
    mouseItemOver(e) {
      if (e[this.keyword] && e.menuList) {
        this.see_module_int = e[this.keyword]
        //设置当前查看二级菜单
        this.currentCheckMenu = e.menuList
      }
    },

    /*
     * 展开 收缩 二级菜单
     * */
    onShrink(bool) {
      this.is_shrink = bool

      this.$emit('onWidthChange', bool)

      let headerAffix = document.getElementsByClassName('view-header')[0]
      let pageContent = document.getElementsByClassName('page-content')[0]
      let pageSider = document.getElementsByClassName('page-sider')[0]
      let maxLeft = '250px'
      if (!this.currentMenu.length) {
        maxLeft = '200px'
      }
      if (!this.menuLists.length || !this.currentMenu.length || this.isShow) {
        maxLeft = '200px'
      }
      if (this.menuLists.length == 0) {
        maxLeft = '0px'
      }
      if (headerAffix) {
        headerAffix.style.left = bool ? '60px' : this.isAlwaysCollapse?'50px':maxLeft
        headerAffix.style.right = '0px'
        headerAffix.style.width = 'auto'
        pageContent.style.paddingTop = '131px'
      } else {
        pageContent.style.paddingTop = '70px'
      }

      if (bool) {
        pageSider.style.width = '60px'
      } else {
        pageSider.style.width = 'auto'
      }
    },

    /*
     * 显示一级菜单
     * */
    showMenu() {
      this.isShow = true

      setTimeout(() => {
        if (this.menuList.length != 0) {
          if (this.menuLists.length != 0) {
            this.menuLists = []
            setTimeout(() => {
              this.menuLists = JSON.parse(JSON.stringify(this.menuList))
              this.is_shrink = false
              this.mouseOver()
            }, 150)
          } else {
            this.menuLists = JSON.parse(JSON.stringify(this.menuList))
          }
        } else {
          this.menuLists = []
        }
        this.onShrink(this.is_shrink)
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import url('~@/assets/style/variable.less');

.sidebar {
  height: 100%;
  display: flex;
}

.isShow {
  width: calc(@pageSiderWidth - 50px);
}

.isHide {
  width: 0px;
}

.menu {
  position: relative;
  z-index: 1;
  box-shadow: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-variant: tabular-nums;
  font-feature-settings: 'tnum';
  margin-bottom: 0;
  padding-left: 0;
  list-style: none;
  outline: none;
  transition: background 0.3s, width 0.2s;
  zoom: 1;
  height: 100%;
  color: hsla(0, 0%, 100%, 0.65);
  background-color: @pageSiderBgColor;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
  padding-top: 1px;

  .menuitem {
    transition: all 0.2s;
    max-width: calc(@pageSiderWidth - 50px);
    color: #bbb;
    font-size: 14px;
    background-color: transparent;
    font-variant: tabular-nums;
    margin-top: 4px;
    margin-bottom: 4px;

    overflow: hidden;
    position: relative;
    transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
      border-color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
      background 0.3s cubic-bezier(0.645, 0.045, 0.355, 1),
      padding 0.15s cubic-bezier(0.645, 0.045, 0.355, 1);
    height: 40px;
    line-height: 40px;
    display: flex;
    align-items: center;
    > div {
      height: 40px;
    }
    span {
      transition: width ease-in-out 0.2s;
      display: inline-block;

      cursor: pointer;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .anticon:nth-child(1) {
      cursor: pointer;
    }
    .anticon {
      min-width: 50px;
      font-size: 14px;
      transition: font-size 0.15s cubic-bezier(0.215, 0.61, 0.355, 1),
        margin 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      display: inline-block;
      font-style: normal;
      line-height: 0;
      text-align: center;
      text-transform: none;
      vertical-align: -0.125em;
      text-rendering: optimizeLegibility;
      -webkit-font-smoothing: antialiased;
      color: #bbb;
    }

    .anticon-right {
      margin: 0px;
    }
  }

  .menuItem_active {
    background-color: #1890ff;
    color: #fff;
    .anticon {
      color: #fff;
    }
  }

  .menuItem_see_active {
    color: #1890ff;

    .anticon {
      color: #1890ff;
    }
  }
  .menu_two_collapse{
    left:50px !important;
   }
  .menu_two {
    position: absolute;
    top: 0px;
    left: calc(@pageSiderWidth - 50px);
    bottom: -2px;
    background: #f7f8fa;
    color: #000;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
      0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;

    writing-mode: vertical-lr;
    -webkit-writing-mode: vertical-lr;
    -ms-writing-mode: vertical-lr;

    .menuItem_two_title {
      display: inline-block;
      margin-bottom: 10px;
      width: calc(@pageSiderWidth - 50px);
      padding: 20px 21px 0px 23px;
      writing-mode: horizontal-tb;
      -webkit-writing-mode: horizontal-tb;
      -ms-writing-mode: horizontal-tb;
      font-size: 14;
      font-weight: bold;

      .menuItem_two_title_content {
        position: relative;
        border-bottom: 1px solid #dddddd;
        padding-bottom: 12px;

        span {
          font-size: 14px;
          font-weight: bold;
          color: #333;
        }

        label {
          position: absolute;
          left: -8px;
          top: 5px;
          width: 2px;
          height: 12px;
          background: #1890ff;
          opacity: 1;
          border-radius: 1px;
        }
      }
    }
 

    .menuItem_three {
      cursor: pointer;
      padding: 5px;
      padding-left: 30px;
      font-size: 14px;
      display: inline-block;
      width: calc(@pageSiderWidth - 50px);
      writing-mode: horizontal-tb;
      -webkit-writing-mode: horizontal-tb;
      -ms-writing-mode: horizontal-tb;
    }

    .menuItem_three:hover {
      color: #0799ff;
    }

    .menuItem_three_active {
      color: #0799ff;
    }
  }
}

.currentMenu::-webkit-scrollbar {
  display: none;
}

.currentMenu {
  position: relative;
  transition: all ease-in-out 0.2s;
  background: #f7f8fa;
  color: #000;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12) !important;
  margin-bottom: -2px;
  overflow-y: auto;
  width: calc(@pageSiderWidth - 50px);

  .currentMenuItem {
    .currentMenuItem_title {
      font-weight: bold;
      margin-bottom: 10px;
      padding: 20px 21px 0px 23px;
      font-size: 14px;
      font-weight: bold;

      .menuItem_two_title_content {
        position: relative;
        border-bottom: 1px solid #dddddd;
        padding-bottom: 12px;

        span {
          font-size: 14px;
          font-weight: bold;
          color: #333;
        }

        label {
          position: absolute;
          left: -8px;
          top: 5px;
          width: 2px;
          height: 12px;
          background: #1890ff;
          opacity: 1;
          border-radius: 1px;
        }
      }
    }

    .currentMenuItem_two {
      padding: 5px 10px;
      position: relative;
      padding-left: 30px;
      font-size: 14px;
    }

    .currentMenuItem_two:hover {
      color: #0799ff;
    }

    .currentMenuItem_two_active {
      color: #0799ff;
    }
  }
}

.menuName {
  position: relative;
  padding-right: 13px;
  cursor: pointer;
}

.count {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  transform-origin: 100% 0;
  z-index: 10;
  min-width: 20px;
  height: 20px;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
  text-align: center;
  background: #f5222d;
  border-radius: 10px;
  padding: 0 8px;
  cursor: pointer;
}
.caret-left {
  position: absolute;
  top: 50%;
  right: 10px;
  margin-top: -125px;
  color: #fff;
  background: #0799ff;
  border-top-left-radius: 50%;
  border-bottom-left-radius: 50%;
  cursor: pointer;
}
.caret-right {
  position: absolute;
  top: 50%;
  left: 60px;
  margin-top: -125px;
  color: #fff;
  background: #0799ff;
  border-top-right-radius: 50%;
  border-bottom-right-radius: 50%;
  cursor: pointer;
}
.shrink {
  //left:calc(-@pageSiderWidth + 60px);
  left: 0px;
}
</style>
